'use client';
import { getTemplateGenerateDesignUrl, urlParams } from '@components/Modules/TemplatesModule/utils/urls';
import useTimer from '@lib/hooks/useTimer';
import { useClientConfig } from '@providers/ClientConfigProvider';
import Anchor from '@ui/Anchor/Anchor';
import { Button } from '@ui/Button/Button';
import { AnalyticsEvent, sendEvent } from '@utils/segment';
import { DesignSizeTypeSetCategory } from 'graphql/generated/types.autogenerated';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import getButtonText from '../TemplatesLayout/getButtonText';

type TemplateButtonsProps = {
  hash: string;
  setHash?: string;
  isStatic?: boolean;
  hideSetButton?: boolean;
  layout?: DesignSizeTypeSetCategory;
};

export default function TemplateButtons({
  hash,
  setHash,
  isStatic = false,
  hideSetButton = false,
  layout,
}: TemplateButtonsProps) {
  const config = useClientConfig();
  const getTime = useTimer();
  const router = useRouter();

  const onClick = useCallback(
    (hash: string, isSetButton: boolean) => () => {
      const secondsOnPage = Math.round(getTime() / 1000);
      const designUrl =
        getTemplateGenerateDesignUrl(hash, config.APP_URL) +
        urlParams({
          isStatic,
          category: isSetButton && layout,
          'skip-onboarding': true,
        });

      sendEvent(AnalyticsEvent.SingleVsSet, {
        hash,
        isSet: isSetButton,
        secondsOnPage,
      });

      // Navigate to the URL
      router.push(designUrl);
    },
    [config.APP_URL, layout, getTime, isStatic, router],
  );

  return (
    <div className="flex w-full flex-col gap-4 sm:w-fit">
      <Anchor aria-label="d" target="_blank" onClick={onClick(hash, false)}>
        <Button size="l" variant="primary" className="w-full sm:w-full">
          Customize this template
        </Button>
      </Anchor>
      {!hideSetButton && (
        <Anchor aria-label="d" target="_blank" onClick={onClick(setHash ?? hash, true)}>
          <Button size="l" variant="outline" className="w-full sm:w-full">
            {getButtonText(layout, true)}
          </Button>
        </Anchor>
      )}
    </div>
  );
}
